let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gQkiB")).then(() => parcelRequire('k60EQ'));